module.exports = __webpack_public_path__ + "img/dz.9740dff8.svg";